export enum FormCustomForms {
    UseCustomers = 'use-customers',
    UseDistributionCustomers = 'use-distribution-customers',
    UseMeteringPoints = 'use-meteringpoints',
    UseHotMeteringPoints = 'use-hot-meteringpoints',
    UseColdMeteringPoints = 'use-cold-meteringpoints'
}